module.exports = __webpack_public_path__ + "img/1736403787368-SH LAOFOOD.png.617f902d.webp";